import React, {
	useEffect
}from "react"
import {
	 Modal, Form
}from "antd"
import {
	useSelector
}from 'react-redux'
import CustomButton from "../../../components/CustomButton"
import CustomInput from "../../../components/CustomInput"
import Notifications from "../../../helpers/Notifications"

const RePriceFormationOrderChangeForm = (props) => {
	const { isSending, changed } = useSelector((state) => state.rePriceFormationOrderReducer)
	const { visible, setVisible, setRecord, record, create, update } = props
	const [form] = Form.useForm()
	useEffect(() => {
		form.resetFields()
		if (record){
			form.setFieldsValue({
				code : record.code,
				name : record.name
			})
		}
	}, [record])

	useEffect(() => {
		if (changed)
			handleCancel()
	}, [changed])

	function handleCancel(){
		form.resetFields()
		setVisible(false)
		setRecord(null)
	}

	const save = () => {
		form.validateFields().then(values => {
			const updateValues = {
				id         : record?.id,
				code       : values.code,
				name       : values.name.trim(),
				createDate : record?.createDate,
				isDeleted  : record?.isDeleted
			}
			const previousValues = {
				id         : record?.id,
				code       : record?.code,
				name       : record?.name,
				createDate : record?.createDate,
				isDeleted  : record?.isDeleted
			}
			if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
				Notifications.errorNotice("Введенные вами данные полностью соответствуют изначальным.", null, 20)
			else
				record ? update(updateValues) : create(updateValues)
		})
	}

	return (
		<Modal
			destroyOnClose
			footer={ [
				<CustomButton
					key="save"
					loading={ isSending }
					type="green"
					onClick={ save }
				>
          Сохранить
				</CustomButton>
			] }
			title={ record ? "Редактирование записи" : "Добавление записи" }
			visible={ visible }
			width={ 900 }
			onCancel={ handleCancel }
		>
			<Form
				form={ form }
				labelAlign="left"
				labelCol={ { span: 6 } }
				name="nsi-form"
				wrapperCol={ { span   : 16,
					offset : 1 } }
			>
				<Form.Item
					label="Код"
					name="code"
					rules={ [
						{
							required : true,
							message  : "Код заполнен некорректно.",
							pattern  : /^[1-9]\d{0,6}$/
						}
					] }
				>
					<CustomInput
						placeholder="Код"
						readOnly={ Boolean(record) }
					/>
				</Form.Item>
				<Form.Item
					label="Название"
					name="name"
					rules={ [
						{
							required   : true,
							whitespace : true,
							min        : 3,
							max        : 200
						}
					] }
				>
					<CustomInput
						maxLength={ 250 }
						placeholder="Название"
					/>
				</Form.Item>
			</Form>
		</Modal>
	)
}
export default RePriceFormationOrderChangeForm
